import React from "react";
import { useNavigate } from "react-router-dom";
const ExpiredPackageView = ({ onNavigateToPricing }) => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-4 text-center">
      <div className="max-w-md w-full bg-white rounded-3xl shadow-2xl p-8 border border-gray-100 transform transition-all">
        {/* Uyarı İkonu */}
        <div className="w-20 h-20 bg-amber-50 text-amber-500 rounded-full flex items-center justify-center mx-auto mb-6 text-3xl shadow-inner">
          ⏳
        </div>

        {/* Başlık ve Açıklama */}
        <h2 className="text-2xl font-bold text-gray-800 mb-3">
          Deneme Süreniz Sona Erdi
        </h2>
        <p className="text-gray-600 text-sm mb-8 leading-relaxed">
          Uygulamamızı denediğiniz için teşekkür ederiz! Tüm içeriklere
          kesintisiz devam etmek, sınıflara ve özel kaynaklara yeniden erişmek
          için lütfen size uygun bir eğitim paketi seçin.
        </p>

        {/* Satın Al / Paketleri İncele Butonu */}
        <button
          onClick={() => navigate("/purchase")} // Paket satın alma sayfasına yönlendiren fonksiyon
          className="w-full bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white font-bold py-4 px-6 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-200 transform hover:-translate-y-0.5"
        >
          Hemen Paket Satın Al / İncele
        </button>
      </div>
    </div>
  );
};

export default ExpiredPackageView;
